/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useRef, useState } from 'react'
import './overview.css'
import GoogleMapReact from 'google-map-react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
// import { useSelector } from 'react-redux'
import moment from 'moment'
import { collection, query, where, orderBy, getDocs, onSnapshot } from "firebase/firestore";
import { useSelector } from 'react-redux'
import { firestore } from '../../../firebase'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import { getCards, getMarkers, getMarkerAnalytics } from '../../../redux/action/card'
// import 'bootstrap/dist/css/bootstrap.css'
import { Unsubscribe } from 'firebase/firestore';
import Select, { MultiValue, ActionMeta } from 'react-select';

interface Card {
    _id: string;
    name: string;
    compiledImageUrl?: string;
    previewUrl?: string;
}

interface Marker {
    _id: string;
    name: string;
    compiledImageUrl: string;
}

interface OverviewProps {
    id?: string;
}

// Define option types for the select components
interface SceneOption {
    value: string;
    label: string;
    image: string;
}

interface MarkerOption {
    value: string;
    label: string;
    image: string;
}

function Overview({ id: propId }: OverviewProps) {
    const dispatch = useDispatch()
    const params = useParams()
    const id = propId || params.id
    const [analyticsData, setAnalyticsData] = useState<any>({
        os: {},
        locationHierarchy: {},
        links: {},
        device: {},
        uniqueImpressions: 0,
        totalInteractions: 0,
        totalClicks: 0,
        totalSocailClicks: 0,
        averageEngagementTime: 0,
        lastHourEngagement: 0,
        previousHourPercentage: 0,
        coords: [],
    })
    const [state, setState] = useState({
        start: moment().subtract(24, 'hours'),
        end: moment(),
    })

    const filters = useRef<{ sceneIds: string[]; markerIds: string[] }>({
        sceneIds: [],
        markerIds: []
    })
    const [defScenes, setDefScenes] = useState<Record<string, Card>>({})
    const [defMarkers, setDefMarkers] = useState<Record<string, Marker>>({})
    const coreData = useRef<Record<string, any>>({})
    const [changedData, setChangedData] = useState<any>({})
    const unsubscribeFn = useRef<Unsubscribe | undefined>(undefined)
    // const eventIds = useRef<any>([])
    const [mapProps, setMapProps] = useState<any>({
        center: {
            lat: 32.779167,
            lng: -96.808891,
        },
        zoom: 5,
    })
    const { start, end } = state
    const handleCallback = (start: moment.Moment, end: moment.Moment) => {
        setState({ start, end });
        // Reset analytics data when date range changes
        setAnalyticsData({
            os: {},
            locationHierarchy: {},
            links: {},
            device: {},
            uniqueImpressions: 0,
            totalInteractions: 0,
            totalClicks: 0,
            totalSocailClicks: 0,
            averageEngagementTime: 0,
            lastHourEngagement: 0,
            previousHourPercentage: 0,
            coords: [],
        });
        // Clear coreData to force fresh data fetch
        coreData.current = {};
        // Fetch updated shared data with new date range
        console.log('start', start.toDate());
        console.log('end', end.toDate());
        fetchSharedData(start.toDate(), end.toDate());
    };

    const [selectedScenes, setSelectedScenes] = useState<string[]>([]);
    const [selectedMarkers, setSelectedMarkers] = useState<string[]>([]);
    const [filterUpdateTrigger, setFilterUpdateTrigger] = useState(0);
    const [sharedData, setSharedData] = useState<{markers: any[], analytics: any[]}>({markers: [], analytics: []});

    // Get cards and markers from Redux store
    const cards = useSelector((state: any) => state.Card?.UserCard as Card[]);
    const markers = useSelector((state: any) => state.Card?.UserMarker as Marker[]);

    useEffect(() => {
        if (!cards) return;
        let scenes: Record<string, Card> = {};
        cards.forEach((card) => {
            scenes[card._id] = card;
        });
        setDefScenes(scenes);
    }, [cards]);

    useEffect(() => {
        let markerMap: Record<string, Marker> = {};
        
        // Add owned markers
        if (Array.isArray(markers)) {
            markers.forEach((marker) => {
                markerMap[marker._id] = marker;
            });
        }
        
        // Add shared markers
        sharedData.markers.forEach((marker) => {
            markerMap[marker._id] = marker;
        });
        
        setDefMarkers(markerMap);
    }, [markers, sharedData.markers]);

    // Effect to sync dropdown state with URL-based filters after data is loaded
    useEffect(() => {
        if (!Array.isArray(cards) || !Array.isArray(markers)) {
            return;
        }
        
        // Ensure dropdown state reflects current filters
        if (filters.current.sceneIds.length > 0) {
            setSelectedScenes(filters.current.sceneIds);
            setSelectedMarkers([]);
        } else if (filters.current.markerIds.length > 0) {
            setSelectedMarkers(filters.current.markerIds);
            setSelectedScenes([]);
        } else {
            setSelectedScenes([]);
            setSelectedMarkers([]);
        }
    }, [cards, markers, sharedData.markers, filterUpdateTrigger]);

    const label = start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY')
    // const card = useSelector((state: any) => state.Card.analytics)
    // const todayCard = useSelector((state: any) => state.Card.todayanalytics)



    useEffect(() => {
        updateValues(changedData)
    }, [changedData])

    // Effect for handling id changes (filter initialization)
    useEffect(() => {
        dispatch(getCards())
        dispatch(getMarkers())

        if (!id) {
            filters.current = {
                sceneIds: [],
                markerIds: []
            };
            setFilterUpdateTrigger(prev => prev + 1);
            return;
        }

        // Handle scene ID (format: "sceneId-s")
        if (id.includes('-s')) {
            const [sceneId] = id.split('-s');
            if (sceneId) {
                filters.current = {
                    sceneIds: [sceneId],
                    markerIds: []
                };
                setFilterUpdateTrigger(prev => prev + 1);
            }
        } else if (id === 'all') {
            filters.current = {
                sceneIds: [],
                markerIds: []
            };
            setFilterUpdateTrigger(prev => prev + 1);
        } else {
            filters.current = {
                sceneIds: [],
                markerIds: [id]
            };
            setFilterUpdateTrigger(prev => prev + 1);
        }
    }, [id]);

    // Fetch shared data function
    const fetchSharedData = async (startDate?: Date, endDate?: Date) => {
        try {
            const result = await dispatch(getMarkerAnalytics({
                startDate: (startDate || state.start.toDate()).toISOString(),
                endDate: (endDate || state.end.toDate()).toISOString()
            }));

            console.log('result', result);
            
            if (result.success) {
                setSharedData({
                    markers: result.markers || [],
                    analytics: result.analytics || []
                });
                
                // Merge shared analytics with existing coreData
                if (result.analytics && result.analytics.length > 0) {
                    result.analytics.forEach((analyticsDoc: any) => {
                        // Normalize timestamps from backend to match Firestore format
                        const normalizedDoc = { ...analyticsDoc };
                        console.log('Normalizing analytics doc:', analyticsDoc._id, analyticsDoc);
                        
                        // Convert timestamp fields to proper Date objects
                        if (normalizedDoc.sessionStart && normalizedDoc.sessionStart._seconds) {
                            normalizedDoc.sessionStart = { toDate: () => new Date(normalizedDoc.sessionStart._seconds * 1000) };
                        } else if (normalizedDoc.sessionStart && normalizedDoc.sessionStart.seconds) {
                            normalizedDoc.sessionStart = { toDate: () => new Date(normalizedDoc.sessionStart.seconds * 1000) };
                        } else if (normalizedDoc.sessionStart && typeof normalizedDoc.sessionStart === 'string') {
                            normalizedDoc.sessionStart = { toDate: () => new Date(normalizedDoc.sessionStart) };
                        }
                        
                        if (normalizedDoc.lastEvent && normalizedDoc.lastEvent._seconds) {
                            normalizedDoc.lastEvent = { toDate: () => new Date(normalizedDoc.lastEvent._seconds * 1000) };
                        } else if (normalizedDoc.lastEvent && normalizedDoc.lastEvent.seconds) {
                            normalizedDoc.lastEvent = { toDate: () => new Date(normalizedDoc.lastEvent.seconds * 1000) };
                        } else if (normalizedDoc.lastEvent && typeof normalizedDoc.lastEvent === 'string') {
                            normalizedDoc.lastEvent = { toDate: () => new Date(normalizedDoc.lastEvent) };
                        }
                        
                        // Normalize event timestamps if they exist
                        if (normalizedDoc.events) {
                            Object.keys(normalizedDoc.events).forEach(eventKey => {
                                const event = normalizedDoc.events[eventKey];
                                if (event.timestamp && event.timestamp._seconds) {
                                    event.timestamp = { toDate: () => new Date(event.timestamp._seconds * 1000) };
                                } else if (event.timestamp && event.timestamp.seconds) {
                                    event.timestamp = { toDate: () => new Date(event.timestamp.seconds * 1000) };
                                } else if (event.timestamp && typeof event.timestamp === 'string') {
                                    event.timestamp = { toDate: () => new Date(event.timestamp) };
                                }
                            });
                        }
                        
                        console.log('Normalized analytics doc:', normalizedDoc._id, normalizedDoc);
                        coreData.current[analyticsDoc._id] = normalizedDoc;
                    });
                    setValues(); // Recalculate analytics with merged data
                }
            }
        } catch (error) {
            console.error('Error fetching shared data:', error);
        }
    };

    // Effect for handling data fetching when id or date range changes
    useEffect(() => {
        // Always fetch real-time data for owned markers
        fetchInitialData().then((unsubscribe) => {
            unsubscribeFn.current = unsubscribe;
        }).catch(error => {
            console.error('Error in fetchInitialData:', error);
        });

        // Also fetch shared data
        fetchSharedData();

        return () => {
            if (unsubscribeFn.current) {
                unsubscribeFn.current();
            }
        };
    }, [id, state.start, state.end]);

    const fetchInitialData = async (): Promise<Unsubscribe> => {
        const uid = localStorage.getItem("userId");
        if (!uid) {
            console.error('No user ID found in localStorage');
            throw new Error('No user ID found');
        }

        const analyticsRef = collection(firestore, `users/${uid}/analytics`);
        const { start: startDate, end: endDate } = state;

        // First, query existing data within the date range
        const initialQuery = query(
            analyticsRef,
            where('lastEvent', '>=', startDate.toDate()),
            where('lastEvent', '<=', endDate.toDate())
        );

        try {
            const initialSnapshot = await getDocs(initialQuery);
            
            const initialData: any = {};
            initialSnapshot.forEach((doc) => {
                initialData[doc.id] = doc.data();
            });
            
            // Replace coreData with the initial data for this date range
            coreData.current = initialData;
            
            // Calculate initial analytics with current filters
            setValues();
        } catch (error) {
            console.error('Error fetching initial data:', error);
        }

        // Set up real-time listener for new data with date range filter
        const unsubscribe = onSnapshot(analyticsRef, (snapshot) => {
            const newData: any = {};
            
            snapshot.docChanges().forEach((change) => {
                const docData = change.doc.data();
                const eventDate = docData.lastEvent?.toDate();
                
                // Only process documents that are within our selected date range
                if (eventDate && eventDate >= startDate.toDate() && eventDate <= endDate.toDate()) {
                    if (change.type === "added" || change.type === "modified") {
                        newData[change.doc.id] = docData;
                    } else if (change.type === "removed") {
                        delete coreData.current[change.doc.id];
                    }
                }
            });

            // Only update if there's actually new data to avoid unnecessary re-renders
            if (Object.keys(newData).length > 0) {
                // Update coreData with new data
                coreData.current = {
                    ...coreData.current,
                    ...newData
                };

                // Force a re-render by updating changedData
                setChangedData(newData);
                
                // Recalculate analytics with the new data
                setValues();
            }
        }, (error) => {
            console.error('Error in onSnapshot:', error);
        });

        return unsubscribe;
    };

    const updateValues = (changedData: any) => {
        if (!changedData || Object.keys(changedData).length === 0) return;

        let aggregatedData: any = { ...analyticsData };

        Object.keys(changedData).forEach((key: any) => {
            const entry = changedData[key];
            const existingEntry = coreData.current[key];

            // Handle new entries
            if (!existingEntry) {
                aggregatedData.uniqueImpressions++;
            }

            // Process events
            if (entry.events) {
                Object.keys(entry.events).forEach((ekey) => {
                    const event = entry.events[ekey];
                    // Skip if event already processed
                    if (existingEntry?.events?.[ekey]) {
                        return;
                    }

                    // Apply filters
                    const matchesMarker = filters.current.markerIds.length === 0 || 
                        filters.current.markerIds.includes(event.markerId);
                    const matchesScene = filters.current.sceneIds.length === 0 || 
                        filters.current.sceneIds.includes(event.sceneId);

                    if (matchesMarker && matchesScene) {
                        // Process event
                        const res = parseEvent(event, entry, aggregatedData);
                        if (res) {
                            aggregatedData = res;
                        }
                    }
                });
            }

            // Update coreData
            coreData.current[key] = { ...entry };
        });

        // Update state with new aggregated data
        setAnalyticsData(aggregatedData);
    };

    const parseEvent = (event:any, entry:any, aggregatedData:any) => {

        if (event.event === 'click') {
            //console.log('click', event)
            aggregatedData.totalClicks++
            aggregatedData.links[event.linkUrl] = aggregatedData.links[event.linkUrl] ? aggregatedData.links[event.linkUrl] + 1 : 1
        }

        if (event.event === 'qr_scan') {
            aggregatedData.device[entry.device] = aggregatedData.device[entry.device] ? aggregatedData.device[entry.device] + 1 : 1
            
            // Create hierarchical location structure
            const country = entry.country || 'Unknown';
            const state = entry.state || 'Unknown';
            const city = entry.city || 'Unknown';
            
            if (!aggregatedData.locationHierarchy[country]) {
                aggregatedData.locationHierarchy[country] = { total: 0, states: {} };
            }
            aggregatedData.locationHierarchy[country].total += 1;
            
            if (!aggregatedData.locationHierarchy[country].states[state]) {
                aggregatedData.locationHierarchy[country].states[state] = { total: 0, cities: {} };
            }
            aggregatedData.locationHierarchy[country].states[state].total += 1;
            
            if (!aggregatedData.locationHierarchy[country].states[state].cities[city]) {
                aggregatedData.locationHierarchy[country].states[state].cities[city] = 0;
            }
            aggregatedData.locationHierarchy[country].states[state].cities[city] += 1;
        }

        return aggregatedData
    }

    const setValues = () => {
        let aggregatedData: any = {
            os: {},
            locationHierarchy: {},
            links: {},
            device: {},
            coords: [],
            uniqueImpressions: 0,
            totalInteractions: 0,
            averageEngagementTime: 0,
            lastHourEngagement: 0,
            previousHourPercentage: 0,
            totalClicks: 0,
            totalSocailClicks: 0,
        }

        let totalEngagementTime = 0;
        let sessionCount = 0;
        let lastHourImpressions = 0;
        let previousHourImpressions = 0;

        const now = new Date();
        const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);
        const twoHoursAgo = new Date(now.getTime() - 2 * 60 * 60 * 1000);

        // Filter data based on selected date range
        const { start: rangeStart, end: rangeEnd } = state;
        const startDate = rangeStart.toDate();
        const endDate = rangeEnd.toDate();

        console.log('Current filters in setValues:', filters.current);

        // Process each entry in coreData
        Object.entries(coreData.current).forEach(([key, entry]: [string, any]) => {
            const lastEvent = entry.lastEvent?.toDate();
            
            // Skip if entry is outside selected date range
            if (!lastEvent || lastEvent < startDate || lastEvent > endDate) {
                return;
            }

            // Check if this entry matches our filters
            let matchesFilter = false;
            let hasValidEvent = false;

            // If no filters are set, include all data
            if (filters.current.markerIds.length === 0 && filters.current.sceneIds.length === 0) {
                matchesFilter = true;
            } else {
                // Check each event against the filters
                Object.values(entry.events || {}).forEach((event: any) => {
                    // Skip if event doesn't have required properties
                    if (!event || !event.sceneId || !event.markerId) {
                        return;
                    }

                    // Check if event matches our filters
                    const matchesMarker = filters.current.markerIds.length === 0 || 
                        filters.current.markerIds.includes(event.markerId);
                    const matchesScene = filters.current.sceneIds.length === 0 || 
                        filters.current.sceneIds.includes(event.sceneId);

                    if (matchesMarker && matchesScene) {
                        hasValidEvent = true;
                    }
                });
                matchesFilter = hasValidEvent;
            }

            if (!matchesFilter) {
                return;
            }

            // Process events for this entry
            Object.values(entry.events || {}).forEach((event: any) => {
                // Skip if event doesn't have required properties
                if (!event || !event.sceneId || !event.markerId) {
                    return;
                }

                // Apply filters to individual events
                const matchesMarker = filters.current.markerIds.length === 0 || event.markerId === filters.current.markerIds[0];
                const matchesScene = filters.current.sceneIds.length === 0 || event.sceneId === filters.current.sceneIds[0];

                if (!matchesMarker || !matchesScene) {
                    return;
                }

                // Process the event
                if (event.event === 'click') {
                    aggregatedData.totalClicks++;
                    if (event.linkUrl) {
                        aggregatedData.links[event.linkUrl] = (aggregatedData.links[event.linkUrl] || 0) + 1;
                    }
                }
                if (event.event === 'qr_scan' || event.event === 'ar_play') {
                    aggregatedData.totalInteractions++;
                    aggregatedData.device[entry.device] = (aggregatedData.device[entry.device] || 0) + 1;
                    
                    // Create hierarchical location structure
                    const country = entry.country || 'Unknown';
                    const state = entry.state || 'Unknown';
                    const city = entry.city || 'Unknown';
                    
                    if (!aggregatedData.locationHierarchy[country]) {
                        aggregatedData.locationHierarchy[country] = { total: 0, states: {} };
                    }
                    aggregatedData.locationHierarchy[country].total += 1;
                    
                    if (!aggregatedData.locationHierarchy[country].states[state]) {
                        aggregatedData.locationHierarchy[country].states[state] = { total: 0, cities: {} };
                    }
                    aggregatedData.locationHierarchy[country].states[state].total += 1;
                    
                    if (!aggregatedData.locationHierarchy[country].states[state].cities[city]) {
                        aggregatedData.locationHierarchy[country].states[state].cities[city] = 0;
                    }
                    aggregatedData.locationHierarchy[country].states[state].cities[city] += 1;
                }
            });

            // Only count unique impressions if the entry matches our filters
            aggregatedData.uniqueImpressions++;

            // Calculate engagement time
            const sessionStart = entry.sessionStart?.toDate();
            if (sessionStart && lastEvent) {
                const engagementDuration = lastEvent.getTime() - sessionStart.getTime();
                if (!isNaN(engagementDuration) && engagementDuration >= 0) {
                    totalEngagementTime += engagementDuration;
                    sessionCount++;
                }
            }

            // Calculate last hour and previous hour metrics
            if (lastEvent >= oneHourAgo && lastEvent <= now) {
                lastHourImpressions++;
            }
            if (lastEvent >= twoHoursAgo && lastEvent < oneHourAgo) {
                previousHourImpressions++;
            }

            // Add coordinates for the map
            if (entry.lat && entry.long) {
                aggregatedData.coords.push({ 
                    lat: entry.lat, 
                    lng: entry.long, 
                    city: entry.city 
                });
            }
        });

        // Calculate averages and percentages
        console.log('Engagement calculation:', { sessionCount, totalEngagementTime });
        if (sessionCount > 0 && totalEngagementTime > 0) {
            aggregatedData.averageEngagementTime = (totalEngagementTime / sessionCount) / (1000 * 60);
        } else {
            aggregatedData.averageEngagementTime = 0;
        }
        console.log('Final averageEngagementTime:', aggregatedData.averageEngagementTime);

        aggregatedData.lastHourEngagement = lastHourImpressions;
        if (previousHourImpressions > 0) {
            aggregatedData.previousHourPercentage = ((lastHourImpressions - previousHourImpressions) / previousHourImpressions) * 100;
        } else if (lastHourImpressions > 0) {
            aggregatedData.previousHourPercentage = 100;
        } else {
            aggregatedData.previousHourPercentage = 0;
        }



        // Update map center if we have coordinates
        if (aggregatedData.coords.length > 0) {
            const lastCoord = aggregatedData.coords[aggregatedData.coords.length - 1];
            setMapProps((prevProps) => ({
                ...prevProps,
                center: {
                    lat: lastCoord.lat,
                    lng: lastCoord.long,
                },
            }));
        }

        setAnalyticsData(aggregatedData);
    };

    const Marker = ({ lat, lng, city }: { lat: number; lng: number, city:string}) => (
        <div
            style={{
                position: 'fixed',
                height: '10px',
                width: '10px',
                backgroundColor: 'red',
                borderRadius: '50%',
                transform: 'translate(-50%, -50%)',
            }}
        ><div style={{marginLeft:'12px'}}>{city}</div></div>
    );

    /*
        useEffect(() => {
            const aggregatedData: any = aggregateAnalyticsData(card?.analytics)
            setAnalyticsData(aggregatedData)
        }, [card, state])
    */
    /*
        useEffect(() => {
            const aggregatedDatas: any = aggregateAnalyticsData(todayCard?.analytics)
            setTodayAnalyticsData(aggregatedDatas)
        }, [todayCard])
    */
        //const totalScans: any = Object.values(analyticsData?.country || {}).reduce((acc: any, value) => acc + value, 0);
        //const totalScansToday: any = Object.values(todayanalyticsData?.country || {}).reduce((acc: any, value) => acc + value, 0);
        //const totalClicksToday: any = Object.values(todayanalyticsData?.links || {}).reduce((acc: any, value) => acc + value, 0);
        //const totalScans: any = 0;
        //const totalScansToday: any = 0;
        //const totalClicksToday: any = 0;

    // Convert cards and markers to select options
    const sceneOptions: SceneOption[] = React.useMemo(() => [
        ...(Array.isArray(cards) ? cards.map(card => ({
            value: card._id,
            label: card.name,
            image: card.previewUrl || card.compiledImageUrl || ''
        })) : [])
    ], [cards]);

    const markerOptions: MarkerOption[] = React.useMemo(() => [
        // Owned markers
        ...(Array.isArray(markers) ? markers.map(marker => ({
            value: marker._id,
            label: marker.name,
            image: marker.compiledImageUrl || ''
        })) : []),
        // Shared markers
        ...(sharedData.markers.map(marker => ({
            value: marker._id,
            label: `${marker.name} (Shared)`,
            image: marker.compiledImageUrl || ''
        })))
    ], [markers, sharedData.markers]);

    // Custom components for both dropdowns
    const customOption = ({ innerProps, data, isSelected }: any) => (
        <div 
            {...innerProps}
            className="d-flex align-items-center gap-2 p-2"
            style={{
                cursor: 'pointer',
                backgroundColor: isSelected ? '#f0f0f0' : 'transparent',
                ':hover': {
                    backgroundColor: '#f0f0f0'
                }
            }}
        >
            {data.image && (
                <img 
                    src={data.image} 
                    alt="" 
                    style={{
                        height: '30px', 
                        width: '30px', 
                        objectFit: 'contain',
                        marginRight: '8px'
                    }}
                />
            )}
            <span>{data.label}</span>
        </div>
    );

    const customMultiValue = ({ data, removeProps }: any) => (
        <div 
            className="d-flex align-items-center gap-2"
            style={{
                backgroundColor: '#e2e8f0',
                borderRadius: '4px',
                padding: '2px 8px',
                margin: '2px'
            }}
        >
            {data.image && (
                <img 
                    src={data.image} 
                    alt="" 
                    style={{
                        height: '20px', 
                        width: '20px', 
                        objectFit: 'contain',
                        marginRight: '4px'
                    }}
                />
            )}
            <span style={{ marginRight: '4px' }}>{data.label}</span>
            <button
                {...removeProps}
                style={{
                    border: 'none',
                    background: 'none',
                    padding: '0 4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: '#666'
                }}
            >
                ×
            </button>
        </div>
    );

    // Add handlers for filter changes
    const handleSceneChange = (
        newValue: MultiValue<SceneOption>,
        actionMeta: ActionMeta<SceneOption>
    ) => {
        console.log('Scene change:', newValue);
        const sceneIds = newValue.map(opt => opt.value);
        setSelectedScenes(sceneIds);
        // Reset marker selection
        setSelectedMarkers([]);
        filters.current = {
            sceneIds,
            markerIds: []
        };
        // Reset analytics data when filter changes
        setAnalyticsData({
            os: {},
            locationHierarchy: {},
            links: {},
            device: {},
            uniqueImpressions: 0,
            totalClicks: 0,
            totalSocailClicks: 0,
            averageEngagementTime: 0,
            lastHourEngagement: 0,
            previousHourPercentage: 0,
            coords: [],
        });
        // Recalculate with new filters
        setValues();
    };

    const handleMarkerChange = (
        newValue: MultiValue<MarkerOption>,
        actionMeta: ActionMeta<MarkerOption>
    ) => {
        console.log('Marker change:', newValue);
        const markerIds = newValue.map(opt => opt.value);
        setSelectedMarkers(markerIds);
        // Reset scene selection
        setSelectedScenes([]);
        filters.current = {
            sceneIds: [],
            markerIds
        };
        // Reset analytics data when filter changes
        setAnalyticsData({
            os: {},
            locationHierarchy: {},
            links: {},
            device: {},
            uniqueImpressions: 0,
            totalClicks: 0,
            totalSocailClicks: 0,
            averageEngagementTime: 0,
            lastHourEngagement: 0,
            previousHourPercentage: 0,
            coords: [],
        });
        // Recalculate with new filters
        setValues();
    };

    return (
        <>
         <div style={{ margin:'10px', fontSize:'20px'}} >
                {selectedScenes.length > 0 ? 
                    `${selectedScenes.length} Scenes Selected` : 
                    selectedMarkers.length > 0 ? 
                    `${selectedMarkers.length} Markers Selected` : 
                    'Overall Project Analytics'}
                {sharedData.markers.length > 0 && (
                    <span style={{ 
                        marginLeft: '10px', 
                        fontSize: '14px', 
                        color: '#0dcaf0',
                        fontWeight: 'bold'
                    }}>
                        📊 Including {sharedData.markers.length} Shared Markers
                    </span>
                )}
            </div>
            <div className='d-flex justify-content-between align-items-center p-5'>
                <div className='d-flex gap-3 align-items-center' style={{ minWidth: '300px' }}>
                    {/* Scene Filter */}
                    <Select
                        className="flex-grow-1"
                        options={sceneOptions}
                        value={sceneOptions.filter(option => selectedScenes.includes(option.value))}
                        onChange={handleSceneChange}
                        placeholder="Filter by Scenes"
                        isMulti
                        isSearchable={true}
                        components={{
                            Option: customOption,
                            MultiValue: customMultiValue
                        }}
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                border: '1px solid #ced4da',
                                '&:hover': {
                                    borderColor: '#ced4da'
                                }
                            }),
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? '#e2e8f0' : 'white',
                                color: 'black',
                                '&:hover': {
                                    backgroundColor: '#f0f0f0'
                                }
                            })
                        }}
                    />

                    {/* Marker Filter */}
                    <Select
                        className="flex-grow-1"
                        options={markerOptions}
                        value={markerOptions.filter(option => selectedMarkers.includes(option.value))}
                        onChange={handleMarkerChange}
                        placeholder="Filter by Prints"
                        isMulti
                        isSearchable={true}
                        components={{
                            Option: customOption,
                            MultiValue: customMultiValue
                        }}
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                border: '1px solid #ced4da',
                                '&:hover': {
                                    borderColor: '#ced4da'
                                }
                            }),
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? '#e2e8f0' : 'white',
                                color: 'black',
                                '&:hover': {
                                    backgroundColor: '#f0f0f0'
                                }
                            })
                        }}
                    />
                </div>

                {/* Date Range Picker */}
                <div className='dropdown d-flex gap-3 align-items-center'>
                    <DateRangePicker
                        initialSettings={{
                            startDate: start.toDate(),
                            endDate: end.toDate(),
                            maxDate: moment().toDate(),
                            ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                    moment().subtract(1, 'days').toDate(),
                                    moment().subtract(1, 'days').toDate(),
                                ],
                                'Last 7 Days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                                'Last 30 Days': [moment().subtract(29, 'days').toDate(), moment().toDate()],
                                'This Month': [
                                    moment().startOf('month').toDate(),
                                    moment().endOf('month').toDate(),
                                ],
                                'Last Month': [
                                    moment().subtract(1, 'month').startOf('month').toDate(),
                                    moment().subtract(1, 'month').endOf('month').toDate(),
                                ],
                            },
                        }}
                        onCallback={handleCallback}
                    >
                        <div
                            id='reportrange'
                            className='col-4'
                            style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                cursor: 'pointer',
                                padding: '5px 10px',
                                width: '100%',
                                color: "#767676"
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ marginTop: "-4px" }}>
                                <path d="M16.9994 6.81836V15.9998C16.9994 16.5521 16.5517 16.9998 15.9994 16.9998H2C1.44772 16.9998 1 16.5521 1 15.9998V6.81836" stroke="#86898A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M1 3.45508C1 2.90279 1.44772 2.45508 2 2.45508H15.9994C16.5517 2.45508 16.9994 2.90279 16.9994 3.45508V6.81855H1V3.45508Z" stroke="#86898A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M5.36523 1V3.90898" stroke="#86898A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12.6357 1V3.90898" stroke="#86898A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span>{label}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 8 5" fill="none" style={{ marginTop: "-4px" }}>
                                <path fillRule="evenodd" clipRule="evenodd" d="M7.51639 0H0.505307C0.304991 0 0.154753 0.0840336 0.0545948 0.210084C-0.0455635 0.336134 0.00451563 0.504202 0.104674 0.630252L3.61022 4.83193C3.71037 4.95798 3.86061 5 4.01085 5C4.16109 5 4.31132 4.91597 4.41148 4.83193L7.91703 0.630252C8.01718 0.504202 8.01718 0.336134 7.9671 0.210084C7.86695 0.0840336 7.71671 0 7.51639 0Z" fill="#86898A" />
                            </svg>
                        </div>
                    </DateRangePicker>
                </div>
            </div>
            <div className='main-overview'>
                <div className='row my-3'>
                    <div className='text-black fw-semibold overview-title'>Overview <i style={{fontSize:'15px'}}>({label})</i></div>
                    <div className='col-6 col-sm-4 col-md'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <div className='over-main'>{analyticsData.totalInteractions}</div>
                                <span className='font-gray2 '>Total Interactions</span>
                            </div>
                            <div style={{ paddingLeft: '25%' }} className='d-none d-md-block'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='2'
                                    height='30'
                                    viewBox='0 0 2 30'
                                    fill='none'
                                >
                                    <path d='M1 0L1 30' stroke='#DDDDDD' strokeWidth='1.6' />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className='col-6 col-sm-4 col-md'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <div className='over-main'>{analyticsData.uniqueImpressions}</div>
                                <span className='font-gray2 '>Unique Sessions</span>
                            </div>
                            <div style={{ paddingLeft: '25%' }} className='d-none d-md-block'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='2'
                                    height='30'
                                    viewBox='0 0 2 30'
                                    fill='none'
                                >
                                    <path d='M1 0L1 30' stroke='#DDDDDD' strokeWidth='1.6' />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className='col-6 col-sm-4 col-md'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <div className='over-main'>{analyticsData.totalClicks}</div>
                                <span className='font-gray2 '>Unique CTA Clicks</span>
                            </div>
                            <div style={{ paddingLeft: '25%' }} className='d-none d-md-block'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='2'
                                    height='30'
                                    viewBox='0 0 2 30'
                                    fill='none'
                                >
                                    <path d='M1 0L1 30' stroke='#DDDDDD' strokeWidth='1.6' />
                                </svg>
                            </div>
                        </div>
                    </div>

                    {/*<div className='col-6 col-sm-4 col-md'>
                        <div className='d-flex  align-items-center'>
                            <div>
                                <div className='over-main d-flex align-items-center'>
                                    {analyticsData.averageEngagementTime.toFixed(1)}{' '}
                                    <div className='d-flex flex-column'>
                                        <span className='font-black fs-6  fw-semibold'>Mins</span>{' '}
                                    </div>
                                </div>
                                <span className='font-gray2 '>Average engagement time</span>
                            </div>
                            <div style={{ paddingLeft: '25%' }} className='d-none d-md-block'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='2'
                                    height='60'
                                    viewBox='0 0 2 60'
                                    fill='none'
                                >
                                    <path d='M1 0L1 60' stroke='#DDDDDD' strokeWidth='1.6' />
                                </svg>
                            </div>
                        </div>
                    </div>*/}
                    <div className='col-6 col-sm-4 col-md '>
                        <div className='over-main font-dark1'>
                           {analyticsData.lastHourEngagement} <span className='font-gray2 fs-6 fw-semibold'>{analyticsData.previousHourPercentage.toFixed(2)}%</span>
                        </div>
                        <span className='font-gray2 '>Interactions in last hour</span>
                    </div>
                </div>
            </div>
            <div className='main-map mt-5'>
                <div style={{ padding: '20px' }}>
                    <div className='d-flex justify-content-between align-items-center pb-2'>
                        <div className='overview-title'>Users Geography</div>
                    </div>

                    <div style={{ height: '60vh', width: '100%' }}>
                       <GoogleMapReact
                        bootstrapURLKeys={{ key: "AIzaSyBG-ra12MZJTnIObQoSRfs6zYRGD8hP-0Y" }}
                        center={mapProps.center}
                        zoom={mapProps.zoom}
                    >
                        {analyticsData.coords.map((coord: any, index) => (
                            <Marker key={`${coord.lat}-${coord.lng}-${index}`} lat={coord.lat} lng={coord.lng} city={coord.city} />
                        ))}
                    </GoogleMapReact>
                    </div>
                </div>
            </div>
            <div className='row font-dark1 my-5'>
                <div className='col-12 col-sm-4 d-flex flex-column '>
                    <div className='main-scancard mb-sm-2'>
                        <h3 className='p-3'>Interactions by location (Total)</h3>
                        <div>
                            {Object.entries(analyticsData?.locationHierarchy || {}).map(([country, countryData]: any) => (
                                <div key={`country-${country}`}>
                                    {/* Country */}
                                    <div className='p-3 border-bottom border-secondary d-flex justify-content-between'>
                                        <div><strong>🌍 {country}</strong></div>
                                        <div><strong>{countryData.total}</strong></div>
                                    </div>
                                    
                                    {/* States under this country */}
                                    {Object.entries(countryData.states || {}).map(([state, stateData]: any) => (
                                        <div key={`state-${country}-${state}`}>
                                            <div className='p-3 border-bottom border-secondary d-flex justify-content-between'>
                                                <div style={{ paddingLeft: '15px' }}>🏛️ {state}</div>
                                                <div>{stateData.total}</div>
                                            </div>
                                            
                                            {/* Cities under this state */}
                                            {Object.entries(stateData.cities || {}).map(([city, cityCount]: any) => (
                                                <div key={`city-${country}-${state}-${city}`} className='p-3 border-bottom border-secondary d-flex justify-content-between'>
                                                    <div style={{ paddingLeft: '30px' }}>🏙️ {city}</div>
                                                    <div>{cityCount}</div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='col-12 col-sm-4 d-flex flex-column'>
                    <div className='main-scancard'>
                        <h3 className='p-3'>Interactions by link (Total)</h3>
                        <>
                            <div>
                                {Object.entries(analyticsData?.links || {}).map(([key, value]: any) => (
                                    <div key={`links-${key}`} className='p-3 border-bottom border-secondary d-flex justify-content-between'>
                                        <div>{key}</div>
                                        <div>{value}</div>
                                    </div>
                                ))}
                            </div>
                        </>
                    </div>
                </div>
                <div className='col-12 col-sm-4 d-flex flex-column'>
                    <div className='main-scancard'>
                        <h3 className='p-3'>Interactions by OS (Total)</h3>
                        {Object.entries(analyticsData?.device || {}).length > 0 &&
                            Object.entries(analyticsData?.device || {}).map(([key, value]: any) => (
                                <div key={`dev-${key}`} className='p-3 border-bottom border-secondary d-flex justify-content-between'>
                                    <div>{key}</div>
                                    <div>{value}</div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Overview
